/**
 * Generates a model value key from the model name and version.
 * (For use with ElSelect with IModel data from Strapi).
 *
 * @param model the model name.
 * @param modelVersion the model version.
 * @returns a "value-key" with the model name and version (assumes model and version pairs are unique).
 */
export const generateModelValueKey = (model: string, modelVersion?: string | null) => {
  return modelVersion ? `${model}.${modelVersion}` : model
}

/**
 * Generates a model display name from the model name and version.
 * (For use with ElSelect with IModel data from Strapi).
 *
 * @param model the model name.
 * @param modelVersion the model version.
 * @returns a display name (assumes model and version pairs are unique).
 */
export const generateModelDisplayName = (model: string, modelVersion?: string | null) => {
  return modelVersion ? `${model} ${modelVersion}` : model
}
